webpackJsonp([2],{

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
// import { testLayout } from '../model';


var state = {
  gridLayout: {},
  gridOptions: {
    columns: 12,
    rowHeight: 50,
    margins: [10, 0],
    isDraggable: true,
    isResizable: true
  },
  columnWidth: 10
};

var getters = {
  /* eslint-disable no-shadow */
  currentGridLayout: function currentGridLayout(state) {
    return state.gridLayout;
  },
  gridOptions: function gridOptions(state) {
    return state.gridOptions;
  },
  columnWidth: function columnWidth(state) {
    return state.columnWidth;
  },
  /* eslint-enable no-shadow */
  getFacetById: function getFacetById(state) {
    return function (id) {
      return state.gridLayout.find(function (facet) {
        return facet.i === id;
      });
    };
  }
};

var actions = {
  /**
   * updateGridOptions store action
   * @param {Object} newGridOptions
   * @since 0.1.25
   */
  updateGridOptions: function updateGridOptions(_ref, newGridOptions) {
    var commit = _ref.commit;

    commit('updateGridOptions', newGridOptions);
  },
  updateFacet: function updateFacet(_ref2, facet) {
    var commit = _ref2.commit;

    commit('updateFacetInLayout', facet);
  },

  /**
   * @name removeFacet
   * @description Removes the facet from the store via the `removeFacetFromLayout` mutation
   * @param {Number} facetId - The Facet ID used to find this facet to remove.
   */
  removeFacet: function removeFacet(_ref3, facetId) {
    var commit = _ref3.commit;

    commit('removeFacetFromLayout', facetId);
  },
  updateFacetOptions: function updateFacetOptions(_ref4, payload) {
    var commit = _ref4.commit;

    commit('updateFacetOptionsMutation', payload);
  },
  updateColumnWidth: function updateColumnWidth(_ref5, width) {
    var commit = _ref5.commit;

    commit('updateColumnWidthMutation', width);
  },
  newLayout: function newLayout(_ref6, layout) {
    var commit = _ref6.commit;

    commit('updateLayout', layout);
  },
  newSchema: function newSchema(_ref7, payload) {
    var commit = _ref7.commit;

    commit('UPDATE_SCHEMA', payload);
  }
};

var mutations = {
  /**
   * updateGridOptions
   * @since 0.1.25
   * @param {Object} newGridOptions
   */
  updateGridOptions: function updateGridOptions(_ref8, newGridOptions) {
    var gridLayout = _ref8.gridLayout;

    state.gridOptions = newGridOptions;
  },
  addLayout: function addLayout(_ref9, text) {
    var gridLayout = _ref9.gridLayout;

    gridLayout.push({
      text: text,
      completed: false
    });
  },
  updateLayout: function updateLayout(_ref10, newLayout) {
    var gridLayout = _ref10.gridLayout;

    state.gridLayout = newLayout;
  },
  addFacetToLayout: function addFacetToLayout(_ref11, facetData) {
    var gridLayout = _ref11.gridLayout;

    gridLayout.push(facetData);
  },
  updateFacetInLayout: function updateFacetInLayout(_ref12, facetData) {
    var gridLayout = _ref12.gridLayout;

    /* eslint-disable prefer-arrow-callback, no-param-reassign */
    gridLayout.forEach(function forEachFacet(facet, index) {
      if (parseInt(facet.id) === parseInt(facetData.id)) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.gridLayout[index], facetData);
      }
    });
    /* eslint-enable prefer-arrow-callback, no-param-reassign */
  },
  updateFacetOptionsMutation: function updateFacetOptionsMutation(_ref13, payload) {
    var gridLayout = _ref13.gridLayout;

    var newFacet = void 0;
    var facetId = void 0;

    gridLayout.forEach(function forEachFacet(facet, index) {
      if (facet.id === payload.facetId) {
        newFacet = facet;
        facetId = index;
        newFacet.model = payload.facetModel;
      }
    });
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.gridLayout[facetId], newFacet);
  },

  /**
   * @name removeFacetFromLayout
   * @description
   *  This will take the incoming facetId; find that facet; and remove it.
   * @todo resize the facets in the grid upon deletion.
   * @param {Object} gridLayout - the state.gridLayout object
   * @param {Number} facetId - the facetId prop
   * @since 0.1.11
   */
  removeFacetFromLayout: function removeFacetFromLayout(_ref14, facetId) {
    var gridLayout = _ref14.gridLayout;

    var index = gridLayout.findIndex(function (facet) {
      return facet.id === facetId;
    });
    state.gridLayout.splice(index, 1);

    //  - This will begin to auto-resize the facets on deletion.
    //  const facetToDie = gridLayout[index];
    //  const temp = state.gridLayout.findIndex(facet => facet.x === (facetToDie.x + facetToDie.w));
    //  console.log('temp: ', temp);
    //  state.gridLayout[temp].w += facetToDie.w;
    //  state.gridLayout[temp].x = facetToDie.x;
  },
  updateColumnWidthMutation: function updateColumnWidthMutation(_ref15, width) {
    var gridLayout = _ref15.gridLayout;

    state.columnWidth = width;
  },

  /**
   * UPDATE_SCHEMA
   * @param {Object} gridLayout - The main gridLayout object
   * @param {Object} payload - consists of id and schema
   * @since 1.2.0
   */
  UPDATE_SCHEMA: function UPDATE_SCHEMA(_ref16, payload) {
    var gridLayout = _ref16.gridLayout;

    var id = payload.id;
    var schema = payload.schema;
    var newFacet = gridLayout.filter(function (facet) {
      return facet.id === parseInt(id);
    });
    console.log('UPDATE_SCHEMA: ', newFacet);
    newFacet[0].schema = schema;

    state.gridLayout.forEach(function forEachFacet(facet, index) {
      if (facet.id === parseInt(id)) {
        // console.log('Old and new schema: ', gridLayout[index].schema, schema);
        // gridLayout[index].schema = schema;
        __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(state.gridLayout, index, newFacet[0]);
      }
    });
  }
};

/**
 * The namespaced true aspect forces any calls to this store module to be prefixed
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(591)
}
var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(209),
  /* template */
  __webpack_require__(606),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IS_UNITLESS */
/* unused harmony export hyphenateRE */
/* unused harmony export addPx */
/* unused harmony export hyphenate */
/* harmony export (immutable) */ __webpack_exports__["e"] = bottom;
/* unused harmony export cloneLayoutItem */
/* unused harmony export cloneLayout */
/* unused harmony export collides */
/* harmony export (immutable) */ __webpack_exports__["f"] = getLayoutItem;
/* unused harmony export getFirstCollision */
/* unused harmony export getAllCollisions */
/* unused harmony export compactItem */
/* unused harmony export getStatics */
/* unused harmony export sortLayoutItemsByRowCol */
/* harmony export (immutable) */ __webpack_exports__["d"] = compact;
/* unused harmony export correctBounds */
/* harmony export (immutable) */ __webpack_exports__["g"] = moveElement;
/* unused harmony export moveElementAwayFromCollision */
/* unused harmony export perc */
/* harmony export (immutable) */ __webpack_exports__["a"] = setTransform;
/* harmony export (immutable) */ __webpack_exports__["b"] = setTopLeft;
/* unused harmony export setTopRight */
/* harmony export (immutable) */ __webpack_exports__["c"] = validateLayout;
/* unused harmony export autoBindHandlers */
/* unused harmony export createMarkup */
/* unused harmony export findItemInArray */
/* unused harmony export findAndRemove */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


/* The following list is defined in React's core */
var IS_UNITLESS = {
  animationIterationCount: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  stopOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};

var hyphenateRE = /([a-z\d])([A-Z])/g;

/**
 * Will add px to the end of style values which are Numbers.
 * @param name
 * @param value
 * @returns {*}
 */
function addPx(name, value) {
  if (typeof value === 'number' && !IS_UNITLESS[name]) {
    return value + 'px';
  }
  return value;
}

/**
 * Hyphenate a camelCase string.
 *
 * @param {String} str
 * @return {String}
 */
function hyphenate(str) {
  return str.replace(hyphenateRE, '$1-$2').toLowerCase();
}

/**
 * Return the bottom coordinate of the layout.
 *
 * @param  {Array} layout Layout array.
 * @return {Number}       Bottom coordinate.
 */
function bottom(layout) {
  var max = 0;
  var bottomY = void 0;

  for (var i = 0, len = layout.length; i < len; i += 1) {
    bottomY = layout[i].y + layout[i].h;
    if (bottomY > max) max = bottomY;
  }
  return max;
}

// Fast path to cloning, since this is monomorphic
function cloneLayoutItem(layoutItem) {
  /* return {
      w: layoutItem.w, h: layoutItem.h, x: layoutItem.x, y: layoutItem.y, i: layoutItem.i,
      minW: layoutItem.minW, maxW: layoutItem.maxW, minH: layoutItem.minH, maxH: layoutItem.maxH,
      moved: Boolean(layoutItem.moved), static: Boolean(layoutItem.static),
      // These can be null
      isDraggable: layoutItem.isDraggable, isResizable: layoutItem.isResizable
    }; */
  return JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(layoutItem));
}

function cloneLayout(layout) {
  var newLayout = Array(layout.length);
  for (var i = 0, len = layout.length; i < len; i += 1) {
    newLayout[i] = cloneLayoutItem(layout[i]);
  }
  return newLayout;
}

/**
 * Given two layoutitems, check if they collide.
 *
 * @return {Boolean}   True if colliding.
 */
function collides(l1, l2) {
  if (l1 === l2) return false; // same element
  if (l1.x + l1.w <= l2.x) return false; // l1 is left of l2
  if (l1.x >= l2.x + l2.w) return false; // l1 is right of l2
  if (l1.y + l1.h <= l2.y) return false; // l1 is above l2
  if (l1.y >= l2.y + l2.h) return false; // l1 is below l2
  return true; // boxes overlap
}

/**
 * Get a layout item by ID. Used so we can override later on if necessary.
 *
 * @param  {Array}  layout Layout array.
 * @param  {String} id     ID
 * @return {LayoutItem}    Item at ID.
 */
function getLayoutItem(layout, id) {
  var layoutItem = void 0;
  for (var i = 0, len = layout.length; i < len; i += 1) {
    if (layout[i].i === id) {
      layoutItem = layout[i];
    }
  }
  return layoutItem;
}

/**
 * Returns the first item this layout collides with.
 * It doesn't appear to matter which order we approach this from, although
 * perhaps that is the wrong thing to do.
 *
 * @param  {Object} layoutItem Layout item.
 * @return {Object|undefined}  A colliding layout item, or undefined.
 */
function getFirstCollision(layout, layoutItem) {
  var firstCollision = void 0;
  for (var i = 0, len = layout.length; i < len; i += 1) {
    if (collides(layout[i], layoutItem)) {
      firstCollision = layout[i];
    }
  }
  return firstCollision;
}

function getAllCollisions(layout, layoutItem) {
  return layout.filter(function (l) {
    return collides(l, layoutItem);
  });
}

/**
 * Compact an item in the layout.
 */
/* eslint-disable no-param-reassign, no-cond-assign */
function compactItem(compareWith, l, verticalCompact) {
  if (verticalCompact) {
    // Move the element up as far as it can go without colliding.
    while (l.y > 0 && !getFirstCollision(compareWith, l)) {
      l.y -= 1;
    }
  }

  // Move it down, and keep moving it down if it's colliding.
  var collided = void 0;
  while (collided = getFirstCollision(compareWith, l)) {
    l.y = collided.y + collided.h;
  }
  return l;
}
/* eslint-enable no-param-reassign, no-cond-assign */

/**
 * Get all static elements.
 * @param  {Array} layout Array of layout objects.
 * @return {Array}        Array of static layout items..
 */
function getStatics(layout) {
  return layout.filter(function (l) {
    return l.static;
  });
}

/**
 * Get layout items sorted from top left to right and down.
 *
 * @return {Array} Array of layout objects.
 * @return {Array}        Layout, sorted static items first.
 */
function sortLayoutItemsByRowCol(layout) {
  return [].concat(layout).sort(function (a, b) {
    if (a.y > b.y || a.y === b.y && a.x > b.x) {
      return 1;
    }
    return -1;
  });
}

/**
 * Given a layout, compact it. This involves going down each y coordinate and removing gaps
 * between items.
 *
 * @param  {Array} layout Layout.
 * @param  {Boolean} verticalCompact Whether or not to compact the layout
 *   vertically.
 * @return {Array}       Compacted Layout.
 */
function compact(layout, verticalCompact) {
  // Statics go in the compareWith array right away so items flow around them.
  var compareWith = getStatics(layout);
  // We go through the items by row and column.
  var sorted = sortLayoutItemsByRowCol(layout);
  // Holding for new items.
  var out = Array(layout.length);

  for (var i = 0, len = sorted.length; i < len; i += 1) {
    var l = sorted[i];

    // Don't move static elements
    if (!l.static) {
      l = compactItem(compareWith, l, verticalCompact);

      // Add to comparison array. We only collide with items before this one.
      // Statics are already in this array.
      compareWith.push(l);
    }

    // Add to output array to make sure they still come out in the right order.
    out[layout.indexOf(l)] = l;

    // Clear moved flag, if it exists.
    l.moved = false;
  }

  return out;
}

/**
 * Given a layout, make sure all elements fit within its bounds.
 *
 * @param  {Array} layout Layout array.
 * @param  {Number} bounds Number of columns.
 */
function correctBounds(layout, bounds) {
  var collidesWith = getStatics(layout);
  for (var i = 0, len = layout.length; i < len; i += 1) {
    var l = layout[i];
    // Overflows right
    if (l.x + l.w > bounds.cols) l.x = bounds.cols - l.w;
    // Overflows left
    if (l.x < 0) {
      l.x = 0;
      l.w = bounds.cols;
    }
    if (!l.static) collidesWith.push(l);else {
      // If this is static and collides with other statics, we must move it down.
      // We have to do something nicer than just letting them overlap.
      while (getFirstCollision(collidesWith, l)) {
        l.y += 1;
      }
    }
  }
  return layout;
}

/**
 * Move an element. Responsible for doing cascading movements of other elements.
 *
 * @param  {Array}      layout Full layout to modify.
 * @param  {LayoutItem} l      element to move.
 * @param  {Number}     [x]    X position in grid units.
 * @param  {Number}     [y]    Y position in grid units.
 * @param  {Boolean}    [isUserAction] If true, designates that the item we're moving is
 *                                     being dragged/resized by th euser.
 */
/* eslint-disable no-param-reassign, no-continue, no-use-before-define */
function moveElement(layout, l, x, y, isUserAction) {
  if (l.static) return layout;

  // Short-circuit if nothing to do.
  // if (l.y === y && l.x === x) return layout;

  var movingUp = y && l.y > y;
  // This is quite a bit faster than extending the object
  if (typeof x === 'number') l.x = x;
  if (typeof y === 'number') l.y = y;
  l.moved = true;

  // If this collides with anything, move it.
  // When doing this comparison, we have to sort the items we compare with
  // to ensure, in the case of multiple collisions, that we're getting the
  // nearest collision.
  var sorted = sortLayoutItemsByRowCol(layout);
  if (movingUp) sorted = sorted.reverse();
  var collisions = getAllCollisions(sorted, l);

  // Move each item that collides away from this element.
  for (var i = 0, len = collisions.length; i < len; i += 1) {
    var collision = collisions[i];
    // console.log('resolving collision between', l.i, 'at', l.y, 'and', collision.i, 'at', collision.y);

    // Short circuit so we can't infinite loop
    if (collision.moved) continue;

    // This makes it feel a bit more precise by waiting to swap for just a bit when moving up.
    if (l.y > collision.y && l.y - collision.y > collision.h / 4) continue;

    // Don't move static items - we have to move *this* element away
    if (collision.static) {
      layout = moveElementAwayFromCollision(layout, collision, l, isUserAction);
    } else {
      layout = moveElementAwayFromCollision(layout, l, collision, isUserAction);
    }
  }

  return layout;
}
/* eslint-enable no-param-reassign, no-continue, no-use-before-define */

/**
 * This is where the magic needs to happen - given a collision, move an element away from the collision.
 * We attempt to move it up if there's room, otherwise it goes below.
 *
 * @param  {Array} layout            Full layout to modify.
 * @param  {LayoutItem} collidesWith Layout item we're colliding with.
 * @param  {LayoutItem} itemToMove   Layout item we're moving.
 * @param  {Boolean} [isUserAction]  If true, designates that the item we're moving is being dragged/resized
 *                                   by the user.
 */
function moveElementAwayFromCollision(layout, collidesWith, itemToMove, isUserAction) {
  // If there is enough space above the collision to put this element, move it there.
  // We only do this on the main collision as this can get funky in cascades and cause
  // unwanted swapping behavior.
  if (isUserAction) {
    // Make a mock item so we don't modify the item here, only modify in moveElement.
    var fakeItem = {
      x: itemToMove.x,
      y: itemToMove.y,
      w: itemToMove.w,
      h: itemToMove.h,
      i: '-1'
    };
    fakeItem.y = Math.max(collidesWith.y - itemToMove.h, 0);
    if (!getFirstCollision(layout, fakeItem)) {
      return moveElement(layout, itemToMove, undefined, fakeItem.y);
    }
  }

  // Previously this was optimized to move below the collision directly, but this can cause problems
  // with cascading moves, as an item may actually leapflog a collision and cause a reversal in order.
  return moveElement(layout, itemToMove, undefined, itemToMove.y + 1);
}

/**
 * Helper to convert a number to a percentage string.
 *
 * @param  {Number} num Any number
 * @return {String}     That number as a percentage.
 */
function perc(num) {
  return num * 100 + '%';
}

function setTransform(top, left, width, height) {
  // Replace unitless items with px
  /* eslint-disable prefer-const */
  var translate = 'translate3d(' + left + 'px,' + top + 'px, 0)';
  /* eslint-enable prefer-const */
  return {
    transform: translate,
    WebkitTransform: translate,
    MozTransform: translate,
    msTransform: translate,
    OTransform: translate,
    width: width + 'px',
    height: height + 'px',
    position: 'absolute'
  };
}

function setTopLeft(top, left, width, height) {
  return {
    top: top + 'px',
    left: left + 'px',
    width: width + 'px',
    height: height + 'px',
    position: 'absolute'
  };
}

/**
 * Just like the setTopLeft method, but instead, it will return a right property instead of left.
 *
 * @param top
 * @param right
 * @param width
 * @param height
 * @returns {{top: string, right: string, width: string, height: string, position: string}}
 */
function setTopRight(top, right, width, height) {
  return {
    top: top + 'px',
    right: right + 'px',
    width: width + 'px',
    height: height + 'px',
    position: 'absolute'
  };
}

/**
 * Validate a layout. Throws errors.
 *
 * @param  {Array}  layout        Array of layout items.
 * @param  {String} [contextName] Context name for errors.
 * @throw  {Error}                Validation error.
 */
/* eslint-disable no-param-reassign */
function validateLayout(layout, contextName) {
  contextName = contextName || 'Layout';
  var subProps = ['x', 'y', 'w', 'h'];
  if (!Array.isArray(layout)) throw new Error(contextName + ' must be an array!');
  for (var i = 0, len = layout.length; i < len; i += 1) {
    var item = layout[i];
    for (var j = 0; j < subProps.length; j += 1) {
      if (typeof item[subProps[j]] !== 'number') {
        throw new Error('VueGridLayout: ' + contextName + '[' + i + '].' + subProps[j] + ' must be a number!');
      }
    }
    if (item.i && typeof item.i !== 'string') {
      throw new Error('VueGridLayout: ' + contextName + '[' + i + '].i must be a string!');
    }
    if (item.static !== undefined && typeof item.static !== 'boolean') {
      throw new Error('VueGridLayout: ' + contextName + '[' + i + '].static must be a boolean!');
    }
  }
}
/* eslint-enable no-param-reassign */

/* eslint-disable no-return-assign, no-param-reassign */
function autoBindHandlers(el, fns) {
  fns.forEach(function (key) {
    return el[key] = el[key].bind(el);
  });
}
/* eslint-enable no-return-assign, no-param-reassign */

/**
 * Convert a JS object to CSS string. Similar to React's output of CSS.
 * @param obj
 * @returns {string}
 */
function createMarkup(obj) {
  var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj);
  if (!keys.length) {
    return '';
  }
  var i = void 0;
  var len = keys.length;
  var result = '';

  for (i = 0; i < len; i += 1) {
    var key = keys[i];
    var val = obj[key];
    result += hyphenate(key) + ':' + addPx(key, val) + ';';
  }

  return result;
}

function findItemInArray(array, property, value) {
  var i = void 0;
  for (i = 0; i < array.length; i += 1) {
    if (array[i][property] === value) {
      return true;
    }
  }

  return false;
}

function findAndRemove(array, property, value) {
  array.forEach(function (result, index) {
    if (result[property] === value) {
      // Remove from array
      array.splice(index, 1);
    }
  });
}

/***/ }),

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_GridLayout__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_GridLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_GridLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GridItem_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GridItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_GridItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_layouts__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_vue_fontawesome__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fortawesome_vue_fontawesome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__fortawesome_vue_fontawesome__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "GridLayout", function() { return __WEBPACK_IMPORTED_MODULE_0__components_GridLayout___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "GridItem", function() { return __WEBPACK_IMPORTED_MODULE_1__components_GridItem_vue___default.a; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GridStore", function() { return __WEBPACK_IMPORTED_MODULE_2__store_modules_layouts__["a"]; });




/* font awesome stuff */





__WEBPACK_IMPORTED_MODULE_4__fortawesome_fontawesome_svg_core__["library"].add(__WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["a" /* faTimesCircle */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["b" /* faArrowsAlt */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["c" /* faCog */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["d" /* faSun */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["e" /* faList */], __WEBPACK_IMPORTED_MODULE_5__fortawesome_free_solid_svg_icons__["f" /* faExpandArrowsAlt */]);

__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('font-awesome-icon', __WEBPACK_IMPORTED_MODULE_6__fortawesome_vue_fontawesome__["FontAwesomeIcon"]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('font-awesome-layers', __WEBPACK_IMPORTED_MODULE_6__fortawesome_vue_fontawesome__["FontAwesomeLayers"]);
__WEBPACK_IMPORTED_MODULE_3_vue__["a" /* default */].component('font-awesome-layers-text', __WEBPACK_IMPORTED_MODULE_6__fortawesome_vue_fontawesome__["FontAwesomeLayersText"]);

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__components_GridLayout___default.a);



/***/ }),

/***/ 206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export offsetXYFromParentOf */
/* harmony export (immutable) */ __webpack_exports__["a"] = getControlPosition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createCoreData;

function isNum(num) {
  // eslint-disable-next-line no-restricted-globals
  return typeof num === 'number' && !isNaN(num);
}

// Get from offsetParent
function offsetXYFromParentOf(evt) {
  var offsetParent = evt.target.offsetParent || document.body;
  var offsetParentRect = evt.offsetParent === document.body ? {
    left: 0,
    top: 0
  } : offsetParent.getBoundingClientRect();

  var x = evt.clientX + offsetParent.scrollLeft - offsetParentRect.left;
  var y = evt.clientY + offsetParent.scrollTop - offsetParentRect.top;

  return { x: x, y: y };
}

// Get {x, y} positions from event.
function getControlPosition(e) {
  return offsetXYFromParentOf(e);
}

// Create an data object exposed by <DraggableCore>'s events
function createCoreData(lastX, lastY, x, y) {
  // State changes are often (but not always!) async. We want the latest value.
  var isStart = !isNum(lastX);

  if (isStart) {
    // If this is our first move, use the x and y as last coords.
    return {
      deltaX: 0,
      deltaY: 0,
      lastX: x,
      lastY: y,
      x: x,
      y: y
    };
  }
  // Otherwise calculate proper values.
  return {
    deltaX: x - lastX,
    deltaY: y - lastY,
    lastX: lastX,
    lastY: lastY,
    x: x,
    y: y
  };
}

/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_utils__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_draggableUtils__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize_png__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__resize_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var interact = __webpack_require__(594);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GridItem',
  props: {
    /**
     * Boolean flag for the facet to allow draggable handle.
     * Non-required; defaults to true.
     */
    isDraggable: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * Boolean option for facet if it's resizable via bottom right handle.
     * Non-required; defaults to true.
     */
    isResizable: {
      type: Boolean,
      required: false,
      default: true
    },
    /**
     * Number that sets the Minimum Height. (@todo Find what this is.  pixels?  Row?)actions: facet:
     * Non-required; defaults to 1
     */
    minH: {
      type: Number,
      required: false,
      default: 1
    },
    /**
     * Number that sets the Minimum Width. (@todo Find what this is.  pixels?  Row?)
     * Non-required; defaults to 1
     */
    minW: {
      type: Number,
      required: false,
      default: 1
    },
    /**
     * Number that sets the Maximum Height. (@todo Find what this is.  pixels?  Row?)
     * Non-required; defaults to Infinity
     */
    maxH: {
      type: Number,
      required: false,
      default: Infinity
    },
    /**
     * Number that sets the Maximum Width. (@todo Find what this is.  pixels?  Row?)
     * Non-required; defaults to Infinity
     */
    maxW: {
      type: Number,
      required: false,
      default: Infinity
    },
    /**
     * Number that is the 'column' starting point of facet.
     * Required, no default.
     */
    x: {
      type: Number,
      required: true,
      default: 1
    },
    /**
     * Number that is the 'row' starting point of facet.
     * Required, no default.
     */
    y: {
      type: Number,
      required: true,
      default: 1
    },
    /**
     * Number that is the width of the facet; in 'columns'
     * Required, no default.
     */
    w: {
      type: Number,
      required: true,
      default: 1
    },
    /**
     * Number that is the height of the facet; in 'row'
     * Required, no default.
     */
    h: {
      type: Number,
      required: true,
      default: 1
    },
    /**
     * The content of the facet.
     * Required, no default
     */
    id: {
      type: [Number],
      required: true,
      default: 1
    },
    /**
     * The content of the facet.
     * Required, no default
     */
    i: {
      type: [String, Number, Object, Array],
      required: true,
      default: ''
    },
    /**
     * @todo FIgure out what this is.
     */
    dragIgnoreFrom: {
      type: String,
      required: false,
      default: 'a, button'
    },
    /**
     * @todo FIgure out what this is.
     */
    dragAllowFrom: {
      type: String,
      required: false,
      default: '.facet-control-move'
    },
    /**
     * @todo FIgure out what this is.
     */
    resizeIgnoreFrom: {
      type: String,
      required: false,
      default: 'a, button'
    },
    /**
     * the data model for the facet
     */
    model: {
      type: Object,
      required: false
    },
    /**
     * The schema defines the config form.
     */
    schema: {
      type: Object,
      required: false
    }
  },
  inject: ['eventBus'],
  data: function data() {
    return {
      isModalVisible: false,
      resizeImg: __WEBPACK_IMPORTED_MODULE_2__resize_png___default.a,
      cols: 1,
      containerWidth: 100,
      rowHeight: 30,
      margin: [10, 10],
      maxRows: Infinity,
      draggable: null,
      resizable: null,
      expanding: null,
      useCssTransforms: true,

      isDragging: false,
      dragging: null,
      isResizing: false,
      resizing: null,
      lastX: NaN,
      lastY: NaN,
      lastW: NaN,
      lastH: NaN,
      style: {},

      dragEventSet: false,
      resizeEventSet: false,

      previousW: null,
      previousH: null,
      previousX: null,
      previousY: null,
      innerX: this.x,
      innerY: this.y,
      innerW: this.w,
      innerH: this.h
    };
  },

  computed: {
    /**
     * This just dynamically sets the resize handle.
     */
    resizableHandleClass: function resizableHandleClass() {
      return 'vue-resizable-handle';
    }
  },
  watch: {
    isDraggable: function isDraggable() {
      this.draggable = this.isDraggable;
    },
    draggable: function draggable() {
      var self = this;
      if (this.interactObj === null || this.interactObj === undefined) {
        this.interactObj = interact(this.$refs.item);
      }
      if (this.draggable) {
        var opts = {
          ignoreFrom: this.dragIgnoreFrom,
          allowFrom: this.dragAllowFrom
        };
        this.interactObj.draggable(opts);
        if (!this.dragEventSet) {
          this.dragEventSet = true;
          this.interactObj.on('dragstart dragmove dragend', function (event) {
            self.handleDrag(event);
          });
        }
      } else {
        this.interactObj.draggable({
          enabled: false
        });
      }
    },
    isResizable: function isResizable() {
      this.resizable = this.isResizable;
    },
    resizable: function resizable() {
      var self = this;
      if (this.interactObj === null || this.interactObj === undefined) {
        this.interactObj = interact(this.$refs.item);
      }
      if (this.resizable) {
        var opts = {
          preserveAspectRatio: false,
          edges: {
            left: false,
            right: '.' + this.resizableHandleClass,
            bottom: '.' + this.resizableHandleClass,
            top: false
          },
          ignoreFrom: this.resizeIgnoreFrom
        };

        this.interactObj.resizable(opts);

        if (!this.resizeEventSet) {
          this.resizeEventSet = true;
          this.interactObj.on('resizestart resizemove resizeend', function (event) {
            self.handleResize(event);
          });
        }
      } else {
        this.interactObj.resizable({
          enabled: false
        });
      }
    },

    /**
     * When the rowHeight changes it updates the computed style component.
     */
    rowHeight: function rowHeight() {
      this.createStyle();
    },

    /**
     * When the cols changes it updates the computed style component.
     */
    cols: function cols() {
      this.createStyle();
    },

    /**
     * When the containerWidth changes it updates the computed style component.
     */
    containerWidth: function containerWidth() {
      this.createStyle();
    },

    /**
     * When x changes it updates the computed style component.
     */
    x: function x(newVal) {
      this.innerX = newVal;
      this.createStyle();
    },

    /**
     * When y changes it updates the computed style component.
     */
    y: function y(newVal) {
      this.innerY = newVal;
      this.createStyle();
    },

    /**
     * When h changes it updates the computed style component.
     */
    h: function h(newVal) {
      this.innerH = newVal;
      this.createStyle();
    },

    /**
     * When w changes it updates the computed style component.
     */
    w: function w(newVal) {
      this.innerW = newVal;
      this.createStyle();
    }
  },
  created: function created() {
    var self = this;

    /**
     * Accessible references of functions for removing in beforeDestroy
     * @param {number} width - the incoming new width to call updateWidth()
     */
    self.updateWidthHandler = function updateWidthHandler(width) {
      self.updateWidth(width);
    };

    /**
     * Exposing method to shrink/redraw grid via compact() function
     * @param {Object} layout
     */
    self.compactHandler = function compactHandler(layout) {
      self.compact(layout);
    };

    self.setDraggableHandler = function setDraggableHandler(isDraggable) {
      if (self.isDraggable === null) {
        self.draggable = isDraggable;
      }
    };

    self.setResizableHandler = function setResizableHandler(isResizable) {
      if (self.isResizable === null) {
        self.resizable = isResizable;
      }
    };

    self.setRowHeightHandler = function setRowHeightHandler(rowHeight) {
      self.rowHeight = rowHeight;
    };

    self.setColNum = function (colNum) {
      self.cols = parseInt(colNum, 10);
    };
    if (this.eventBus) {
      this.eventBus.$on('updateWidth', self.updateWidthHandler);
      this.eventBus.$on('compact', self.compactHandler);
      this.eventBus.$on('setDraggable', self.setDraggableHandler);
      this.eventBus.$on('setResizable', self.setResizableHandler);
      this.eventBus.$on('setRowHeight', self.setRowHeightHandler);
      this.eventBus.$on('setColNum', self.setColNum);
    }
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    // Remove listeners
    this.eventBus.$off('updateWidth', self.updateWidthHandler);
    this.eventBus.$off('compact', self.compactHandler);
    this.eventBus.$off('setDraggable', self.setDraggableHandler);
    this.eventBus.$off('setResizable', self.setResizableHandler);
    this.eventBus.$off('setRowHeight', self.setRowHeightHandler);
    this.eventBus.$off('setColNum', self.setColNum);
  },
  mounted: function mounted() {
    // @todo - this looks at this.$parent, should pass in?
    this.cols = this.$parent.colNum;
    this.rowHeight = this.$parent.rowHeight;
    this.containerWidth = this.$parent.width !== null ? this.$parent.width : 100;
    this.margin = this.$parent.margin !== undefined ? this.$parent.margin : [10, 10];
    this.maxRows = this.$parent.maxRows;

    if (this.isDraggable === null) {
      this.draggable = this.$parent.isDraggable;
    } else {
      this.draggable = this.isDraggable;
    }

    if (this.isResizable === null) {
      this.resizable = this.$parent.isResizable;
    } else {
      this.resizable = this.isResizable;
    }

    this.useCssTransforms = this.$parent.useCssTransforms;
    this.createStyle();
  },

  methods: {
    /**
     * @name expandItem
     * @description This will expand the modal full screen
     * @param {Number} id - The Facet ID; to pass in to find the content.
     * @todo redisplay the content pieces in the modal slot.
     */
    expandItem: function expandItem(id) {
      this.expanding = true;
      this.isModalVisible = true;
    },

    /**
     * @name showModal
     * @description Shows the Modal.
     * Need to $emit the data up to the GridLayout, so we can open the modal OUTSIDE the grid-layout container.
     */
    showModal: function showModal() {
      this.expanding = false;
      var modalConfig = {
        isModalVisible: true,
        facetId: this.id,
        model: this.model,
        schema: this.schema
      };
      this.$parent.$emit('openModal', modalConfig);
    },

    /**
     * @name closeModal
     * @description Closes the Modal
     */
    closeModal: function closeModal() {
      this.isModalVisible = false;
    },

    /**
     * @name removeItem
     * @description
     *  Dispatch to the layouts/removeFacets store the facet ID.
     * @since 0.1.11
     * @param {Number} id - the Facet ID; which is the passed in facetId prop.
     */
    removeItem: function removeItem(id) {
      __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('layouts/removeFacet', id);
    },
    /**
     * @name createStyle
     * @description
     *  This creates the positioning style for the facet.
     */
    createStyle: function createStyle() {
      // Checks to see if the facet will size to the right outside the grid.
      if (this.x + this.w > this.cols) {
        this.innerX = 0;
        this.innerW = this.w > this.cols ? this.cols : this.w;
      } else {
        this.innerX = this.x;
        this.innerW = this.w;
      }
      // Calls the `calcPosition` function to return an array of numbers.
      var pos = this.calcPosition(this.innerX, this.innerY, this.innerW, this.innerH);

      if (this.isDragging) {
        pos.top = this.dragging.top;
        pos.left = this.dragging.left;
      }
      if (this.isResizing) {
        pos.width = this.resizing.width;
        pos.height = this.resizing.height;
      }
      var style = void 0;
      // CSS Transforms support (default)
      if (this.useCssTransforms) {
        style = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["a" /* setTransform */])(pos.top, pos.left, pos.width, pos.height);
      } else {
        // top,left (slow)
        style = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_utils__["b" /* setTopLeft */])(pos.top, pos.left, pos.width, pos.height);
      }
      this.style = style;
    },

    /**
     * @name handleResize
     * @description The Resizing Function that is called when the facet is resized.
     * @param {Object} event - the passed in event.
     */
    handleResize: function handleResize(event) {
      // Get the current drag point from the event. This is used as the offset.
      var position = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_draggableUtils__["a" /* getControlPosition */])(event);
      var x = position.x,
          y = position.y;

      var newSize = { width: 0, height: 0 };
      var calcPos = void 0;
      var coreEvent = void 0;

      switch (event.type) {
        default:
          // for eslint
          break;
        case 'resizestart':
          this.previousW = this.innerW;
          this.previousH = this.innerH;
          calcPos = this.calcPosition(this.innerX, this.innerY, this.innerW, this.innerH);
          newSize.width = calcPos.width;
          newSize.height = calcPos.height;
          this.resizing = newSize;
          this.isResizing = true;
          break;
        case 'resizemove':
          coreEvent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_draggableUtils__["b" /* createCoreData */])(this.lastW, this.lastH, x, y);
          newSize.width = this.resizing.width + coreEvent.deltaX;
          newSize.height = this.resizing.height + coreEvent.deltaY;

          this.resizing = newSize;
          break;
        case 'resizeend':
          calcPos = this.calcPosition(this.innerX, this.innerY, this.innerW, this.innerH);
          newSize.width = calcPos.width;
          newSize.height = calcPos.height;

          this.resizing = null;
          this.isResizing = false;
          break;
      }

      // Get new WH
      var pos = this.calcWH(newSize.height, newSize.width);
      if (pos.w < this.minW) {
        pos.w = this.minW;
      }
      if (pos.w > this.maxW) {
        pos.w = this.maxW;
      }
      if (pos.h < this.minH) {
        pos.h = this.minH;
      }
      if (pos.h > this.maxH) {
        pos.h = this.maxH;
      }

      if (pos.h < 1) {
        pos.h = 1;
      }
      if (pos.w < 1) {
        pos.w = 1;
      }

      this.lastW = x;
      this.lastH = y;

      if (this.innerW !== pos.w || this.innerH !== pos.h) {
        this.$emit('resize', this.i, pos.h, pos.w, newSize.height, newSize.width);
      }
      if (event.type === 'resizeend' && (this.previousW !== this.innerW || this.previousH !== this.innerH)) {
        this.$emit('resized', this.i, pos.h, pos.w, newSize.height, newSize.width);
      }
      this.eventBus.$emit('resizeEvent', event.type, this.i, this.innerX, this.innerY, pos.h, pos.w);
    },
    handleDrag: function handleDrag(event) {
      var parentRect = void 0; // parent bounding box
      var clientRect = void 0; // this bounding box
      var coreEvent = void 0;

      var position = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_draggableUtils__["a" /* getControlPosition */])(event);
      var newPosition = {
        top: 0,
        left: 0
      };
      var x = position.x,
          y = position.y;

      // Quick check to see if it's in middle of resizing

      if (this.isResizing) {
        return;
      }

      switch (event.type) {
        default:
          // for eslint
          break;
        case 'dragstart':
          this.previousX = this.innerX;
          this.previousY = this.innerY;

          parentRect = event.target.offsetParent.getBoundingClientRect();
          clientRect = event.target.getBoundingClientRect();
          newPosition.left = clientRect.left - parentRect.left;
          newPosition.top = clientRect.top - parentRect.top;
          this.dragging = newPosition;
          this.isDragging = true;
          break;
        case 'dragend':
          if (!this.isDragging) return;
          parentRect = event.target.offsetParent.getBoundingClientRect();
          clientRect = event.target.getBoundingClientRect();
          newPosition.left = clientRect.left - parentRect.left;
          newPosition.top = clientRect.top - parentRect.top;
          this.dragging = null;
          this.isDragging = false;
          break;
        case 'dragmove':
          coreEvent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_draggableUtils__["b" /* createCoreData */])(this.lastX, this.lastY, x, y);
          newPosition.left = this.dragging.left + coreEvent.deltaX;
          newPosition.top = this.dragging.top + coreEvent.deltaY;
          this.dragging = newPosition;
          break;
      }

      var pos = this.calcXY(newPosition.top, newPosition.left);

      this.lastX = x;
      this.lastY = y;

      if (this.innerX !== pos.x || this.innerY !== pos.y) {
        this.$emit('move', this.i, pos.x, pos.y);
      }
      if (event.type === 'dragend' && (this.previousX !== this.innerX || this.previousY !== this.innerY)) {
        this.$emit('moved', this.i, pos.x, pos.y);
      }
      this.eventBus.$emit('dragEvent', event.type, this.i, pos.x, pos.y, this.innerH, this.innerW);
    },

    /**
     * @name calcPosition
     * @description Calculates the position of the facet
     * @param {Number} x - the X Position
     * @param {Number} y - the Y Position
     * @param {Number} w - the Number of Columns across the Layout the facet goes.
     * @param {Number} h - the Number of Rows across the Layout the facet goes.
     * @returns {Object} - The {left, top, width, height } Object
     */
    calcPosition: function calcPosition(x, y, w, h) {
      var colWidth = this.calcColWidth();
      var out = {
        left: Math.round(colWidth * x + (x + 1) * this.margin[0]),
        top: Math.round(this.rowHeight * y + (y + 1) * this.margin[1]),
        // 0 * Infinity === NaN, which causes problems with resize constriants;
        // Fix this if it occurs.
        // Note we do it here rather than later because Math.round(Infinity) causes deopt
        width: w === Infinity ? w : Math.round(colWidth * w + Math.max(0, w - 1) * this.margin[0]),
        height: h === Infinity ? h : Math.round(this.rowHeight * h + Math.max(0, h - 1) * this.margin[1])
      };
      return out;
    },

    /**
     * Translate x and y coordinates from pixels to grid units.
     * @param  {Number} top  Top position (relative to parent) in pixels.
     * @param  {Number} left Left position (relative to parent) in pixels.
     * @return {Object} x and y in grid units.
     */
    calcXY: function calcXY(top, left) {
      var colWidth = this.calcColWidth();

      var x = Math.round((left - this.margin[0]) / (colWidth + this.margin[0]));
      var y = Math.round((top - this.margin[1]) / (this.rowHeight + this.margin[1]));

      // Capping
      x = Math.max(Math.min(x, this.cols - this.innerW), 0);
      y = Math.max(Math.min(y, this.maxRows - this.innerH), 0);

      return { x: x, y: y };
    },

    /**
     * Generates column width.
     * - ContainerWidth - margin, * cols+1 / cols
     * @returns {Number}
     */
    calcColWidth: function calcColWidth() {
      var newWidth = (this.containerWidth - this.margin[0] * (this.cols + 1)) / this.cols;
      if (this.containerWidth > 50) {
        __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('layouts/updateColumnWidth', newWidth);
        return newWidth;
      }
    },


    /**
     * Given a height and width in pixel values, calculate grid units.
     * @param  {Number} height Height in pixels.
     * @param  {Number} width  Width in pixels.
     * @return {Object} w, h as grid units.
     */
    calcWH: function calcWH(height, width) {
      var colWidth = this.calcColWidth();

      var w = Math.round((width + this.margin[0]) / (colWidth + this.margin[0]));
      var h = Math.round((height + this.margin[1]) / (this.rowHeight + this.margin[1]));

      // Capping
      w = Math.max(Math.min(w, this.cols - this.innerX), 0);
      h = Math.max(Math.min(h, this.maxRows - this.innerY), 0);
      return { w: w, h: h };
    },
    updateWidth: function updateWidth(width, colNum) {
      this.containerWidth = width;
      if (colNum !== undefined && colNum !== null) {
        this.cols = colNum;
      }
    },

    /**
     * Method to shrink vertical facets; updating the grid.
     */
    compact: function compact() {
      this.createStyle();
    }
  }
});

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_utils__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GridItem_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GridItem_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__GridItem_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









// For smoother scrolling, 3rd party lib.
var elementResizeDetectorMaker = __webpack_require__(581);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'GridLayout',
  provide: function provide() {
    return {
      eventBus: null
    };
  },

  components: {
    GridItem: __WEBPACK_IMPORTED_MODULE_2__GridItem_vue___default.a,
    Modal: __WEBPACK_IMPORTED_MODULE_3__Modal___default.a
  },
  props: {
    /**
     * If true, the container height swells and contracts to fit contents
     */
    autoSize: {
      type: Boolean,
      default: true
    },
    /**
     * Arbitrary number that is divided by viewport width, and that's the column.
     */
    colNum: {
      type: Number,
      default: 12
    },
    /**
     * Pixel height of each row.
     */
    rowHeight: {
      type: Number,
      default: 150
    },
    /**
     * Maximum Number of Rows
     * Default to Infinity
     */
    maxRows: {
      type: Number,
      default: Infinity
    },
    /**
     * Array that is the overall margins for the main layout object.
     */
    margin: {
      type: Array,
      default: function _default() {
        return [10, 10];
      }
    },
    /**
     * Boolean if all facets are draggable.
     */
    isDraggable: {
      type: Boolean,
      default: true
    },
    /**
     * Boolean if all facets are resizable.
     */
    isResizable: {
      type: Boolean,
      default: true
    },
    /**
     * todo remove this?
     * Figure out how this is used.
     */
    useCssTransforms: {
      type: Boolean,
      default: true
    },
    /**
     * todo remove this - move into store?
     */
    verticalCompact: {
      type: Boolean,
      default: true
    },
    /**
     * The structure and content of the layout grid.
     *
     * Array of Objects that contain the facets; and the layout items for each facet.
     */
    layout: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      isModalVisible: false,
      modalConfig: {
        model: null,
        schema: null
      },
      width: null,
      mergedStyle: {},
      lastLayoutLength: 0,
      isDragging: false,
      placeholder: {
        x: 0,
        y: 0,
        w: 0,
        h: 0,
        i: -1
      }
    };
  },

  watch: {
    /**
     * When width changes the eventBus $emits updateWidth with new Width, then updates Height.
     * @event updateWidth - Event with new Width
     */
    width: function width() {
      this.$nextTick(function updateWidth() {
        this.eventBus.$emit('updateWidth', this.width);
        this.updateHeight();
      });
    },
    layout: function layout() {
      this.layoutUpdate();
    },

    /**
     * When Column Numbers Change it emits the new Column Number
     * @event setColNum
     */
    colNum: function colNum(val) {
      this.eventBus.$emit('setColNum', val);
    },

    /**
     * When Row Height changes it emits the new Row Height Number
     * @event setRowHeight
     */
    rowHeight: function rowHeight() {
      this.eventBus.$emit('setRowHeight', this.rowHeight);
    },

    /**
     * If you change the draggable aspect this will emit the new boolean
     * @event setDraggable
     */
    isDraggable: function isDraggable() {
      this.eventBus.$emit('setDraggable', this.isDraggable);
    },

    /**
     * If you change the resizable aspect this will emit the new boolean
     * @event setResizable
     */
    isResizable: function isResizable() {
      this.eventBus.$emit('setResizable', this.isResizable);
    }
  },
  created: function created() {
    var self = this;

    this.$on('openModal', function (modalConfig) {
      this.modalConfig = modalConfig;
      this.isModalVisible = true;
    });

    this.$on('close', function () {
      this.isModalVisible = false;
    });

    /**
     * Accessible references of functions for removing in beforeDestroy
     * @todo This should be passed in as a prop; and avoid all the events spawning.
     */
    self.resizeEventHandler = function resizeEventHandler(eventType, id, x, y, h, w) {
      self.resizeEvent(eventType, id, x, y, h, w);
    };
    /**
     * @todo This should be passed in as a prop; and avoid all the events spawning.
     */
    self.dragEventHandler = function dragEventHandler(eventType, id, x, y, h, w) {
      self.dragEvent(eventType, id, x, y, h, w);
    };

    /**
     * Creating separate Vue for EventBus holding.
     * Attaches to root, used as bypass for all internal events.
     * @event resizeEvent
     * @event dragEvent
     */
    self._provided.eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
    self.eventBus = self._provided.eventBus;
    self.eventBus.$on('resizeEvent', self.resizeEventHandler);
    self.eventBus.$on('dragEvent', self.dragEventHandler);
  },
  beforeDestroy: function beforeDestroy() {
    var self = this;
    // Remove listeners
    this.eventBus.$off('resizeEvent', self.resizeEventHandler);
    this.eventBus.$off('dragEvent', self.dragEventHandler);
    window.removeEventListener('resize', self.onWindowResize);
  },
  mounted: function mounted() {
    this.$nextTick(function mounted() {
      var self = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["c" /* validateLayout */])(this.layout);
      this.$nextTick(function () {
        if (self.width === null) {
          self.onWindowResize();
          window.addEventListener('resize', self.onWindowResize);
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["d" /* compact */])(self.layout, self.verticalCompact);

        self.updateHeight();
        self.$nextTick(function () {
          // <- For ultra performance.
          var erd = elementResizeDetectorMaker({
            strategy: 'scroll'
          });
          erd.listenTo(self.$refs.item, function () {
            self.onWindowResize();
          });
        });
      });
      window.onload = function onload() {
        if (self.width === null) {
          self.onWindowResize();
          window.addEventListener('resize', self.onWindowResize);
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["d" /* compact */])(self.layout, self.verticalCompact);

        self.updateHeight();
        self.$nextTick(function () {
          // <- For ultra performance.
          var erd = elementResizeDetectorMaker({
            strategy: 'scroll'
          });
          erd.listenTo(self.$refs.item, function () {
            self.onWindowResize();
          });
        });
      };
    });
  },

  methods: {
    /**
     * @name closeModal
     * @description Closes the Modal
     */
    closeModal: function closeModal() {
      this.isModalVisible = false;
    },

    /*
     * This catches the event being passed up.
     *
     * This is done so the whole layout object can be modified
     * (as resizing the facet can force changes to other facets)
     *
     * @todo investigate moving layout into prop; and having facet or STORE do
     * the proper mutation.
     */
    layoutUpdate: function layoutUpdate() {
      if (this.layout !== undefined) {
        if (this.layout.length !== this.lastLayoutLength) {
          this.lastLayoutLength = this.layout.length;
        }
        /**
         * @todo check on this; this vertically compacts the layout,
         * then re-emits the width; and updates the height.
         */
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["d" /* compact */])(this.layout, this.verticalCompact);
        this.eventBus.$emit('updateWidth', this.width);
        this.updateHeight();
      }
    },

    /**
     * This updates the 'mergedStyle' variable and updates the height.
     */
    updateHeight: function updateHeight() {
      this.mergedStyle = {
        height: this.containerHeight()
      };
    },

    /**
     * Checks this.$refs; which is the HTML element in the DOM.
     *
     * If it's rendered it gives the offsetWidth.
     */
    onWindowResize: function onWindowResize() {
      if (this.$refs !== null && this.$refs.item !== null && this.$refs.item !== undefined) {
        this.width = this.$refs.item.offsetWidth;
      }
    },

    /**
     * This sets the css style based on the layout, rowHeight, margin.
     * @returns String
     */
    containerHeight: function containerHeight() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["e" /* bottom */])(this.layout) * (this.rowHeight + this.margin[1] + this.margin[1]) + 'px';
    },

    /**
     * dragEvent
     */
    dragEvent: function dragEvent(eventName, id, x, y, h, w) {
      if (eventName === 'dragmove' || eventName === 'dragstart') {
        this.placeholder.id = id;
        this.placeholder.x = x;
        this.placeholder.y = y;
        this.placeholder.w = w;
        this.placeholder.h = h;
        this.$nextTick(function isDragging() {
          this.isDragging = true;
        });
        this.eventBus.$emit('updateWidth', this.width);
      } else {
        this.$nextTick(function isDragging() {
          this.isDragging = false;
        });
      }
      var l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["f" /* getLayoutItem */])(this.layout, id);
      // GetLayoutItem sometimes returns null object
      if (l === undefined || l === null) {
        l = { x: 0, y: 0 };
      }
      l.x = x;
      l.y = y;
      // Move the element to the dragged location.
      this.layout = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["g" /* moveElement */])(this.layout, l, x, y, true);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["d" /* compact */])(this.layout, this.verticalCompact);
      // needed because vue can't detect changes on array element properties
      this.eventBus.$emit('compact');
      this.updateHeight();
      // if (eventName === 'dragend') this.$emit('layout-updated', this.layout);
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('layouts/updateFacet', this.layout);
    },

    /**
     * resizeEvent
     */
    resizeEvent: function resizeEvent(eventName, id, x, y, h, w) {
      if (eventName === 'resizestart' || eventName === 'resizemove') {
        this.placeholder.id = id;
        this.placeholder.i = id;
        this.placeholder.x = x;
        this.placeholder.y = y;
        this.placeholder.w = w;
        this.placeholder.h = h;
        this.$nextTick(function isDragging() {
          this.isDragging = true;
        });
        this.eventBus.$emit('updateWidth', this.width);
      } else {
        this.$nextTick(function isDragging() {
          this.isDragging = false;
        });
      }
      var l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["f" /* getLayoutItem */])(this.layout, id);
      // GetLayoutItem sometimes return null object
      if (l === undefined || l === null) {
        l = { h: 0, w: 0 };
      }
      l.h = h;
      l.w = w;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_utils__["d" /* compact */])(this.layout, this.verticalCompact);
      this.eventBus.$emit('compact');
      this.updateHeight();
      if (eventName === 'resizeend') this.$emit('layout-updated', this.layout);

      // Passing modified facet to store.
      var updatedFacet = this.layout.find(function (facet) {
        return facet.id === parseInt(id, 10);
      });
      __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('layouts/updateFacet', updatedFacet);
    }
  }
});

/***/ }),

/***/ 211:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_generator__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_generator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_form_generator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal',
  props: {
    /**
     * data model of the content items of the facet.
     */
    model: {
      type: Object,
      required: true,
      default: function _default() {
        return {
          config: {}
        };
      }
    },
    /**
     * schema is the JSON form schema that exposes items in the config modal; mapped to the model group.
     */
    schema: {
      type: Object,
      required: false
    },
    /**
     * the passed in Facet ID, to look up in the layout.
     */
    facetId: {
      type: Number,
      required: true
    },
    /**
     * Boolean flag if the facet is visible or hidden.
     */
    isModalVisible: {
      type: Boolean,
      required: true,
      default: false
    },
    /**
     * Boolean flag if the facet is expandable.
     */
    expanding: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    'vue-form-generator': __WEBPACK_IMPORTED_MODULE_0_vue_form_generator___default.a.component
  },
  data: function data() {
    return {
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true
      }
    };
  },
  methods: {
    /**
     * @name submit
     * @param {Object} e - The passed in event
     * @description This will collect the facet model and id, and passes into the vuex store.  The normal submit event is prevented (thus the event param).
     * @event {Object} store.dispatch - passes payload to store `layouts/updateFacetOptions`.
     * @event {String} $emit - this.$emit's to 'close' to $parent.
     */
    submit: function submit(e) {
      var payload = {
        facetModel: this.model,
        facetId: this.facetId
        // console.log('[grid]     submitting config: ', payload);
      };__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('layouts/updateFacetOptions', payload);
      // this.$parent.$emit('submittingGridOptions', payload);
      this.$parent.$emit('close');
      // this.$emit('submittingGridOptions', payload);
      // this.$emit('close');
      e.preventDefault();
    },

    /**
     * @name close
     * @description This emits the close event to close the modal.
     * @event {String} $emit - this.$emit's to 'close' to $parent.
     */
    close: function close() {
      this.$parent.$emit('close');
    }
  },
  mounted: function mounted() {
    var _this = this;

    /**
     * adds Evemt Listener when modal is open for `esc` key; which will close Modal without saving.
     */
    document.addEventListener('keydown', function (e) {
      if (_this.isModalVisible && e.keyCode === 27) {
        _this.close();
      }
    });
  }
});

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_layouts__ = __webpack_require__(103);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    layouts: __WEBPACK_IMPORTED_MODULE_2__modules_layouts__["a" /* default */]
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  strict: false
}));

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(588)
}
var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(208),
  /* template */
  __webpack_require__(603),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 588:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAWCAYAAAAvg9c4AAAACXBIWXMAAAsSAAALEgHS3X78AAAAQUlEQVQ4jWP8//8/A7XA1CkTDoCMYqGaiRBgDyKZqGwow6iho4aOGjpq6Kih1AMssCqAqobCqgBqG+pIVRMZGBgAKUEI4u2urL0AAAAASUVORK5CYII="

/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(592)
}
var Component = __webpack_require__(26)(
  /* script */
  __webpack_require__(211),
  /* template */
  __webpack_require__(607),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 603:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "item",
    staticClass: "vue-grid-item",
    class: {
      'vue-resizable': _vm.resizable,
      'resizing': _vm.isResizing,
      'vue-draggable-dragging': _vm.isDragging,
      'cssTransforms': _vm.useCssTransforms,
      'disable-userselect': _vm.isDragging
    },
    style: (_vm.style)
  }, [(_vm.$slots['header']) ? _c('div', {
    staticClass: "grid-item-header level"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [(_vm.model && _vm.schema) ? _c('font-awesome-icon', {
    staticClass: "facet-control",
    attrs: {
      "icon": "list",
      "size": "xs"
    },
    on: {
      "click": function($event) {
        _vm.showModal()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isDraggable) ? _c('font-awesome-icon', {
    staticClass: "facet-control-move facet-control",
    attrs: {
      "icon": "arrows-alt",
      "size": "xs"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.model.maximizable) ? _c('font-awesome-icon', {
    staticClass: "facet-control",
    attrs: {
      "icon": "expand-arrows-alt",
      "size": "xs"
    },
    on: {
      "click": function($event) {
        _vm.expandItem(_vm.id)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.model.removeable) ? _c('font-awesome-icon', {
    staticClass: "facet-control",
    attrs: {
      "icon": "times-circle",
      "size": "xs"
    },
    on: {
      "click": function($event) {
        _vm.removeItem(_vm.id)
      }
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('div', {}, [(_vm.$slots['body-left']) ? _c('div', {
    staticClass: "grid-item-body-left column"
  }, [_vm._t("body-left", null, {
    $ref: "body-left"
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {}, [_c('div', [_vm._t("default"), _vm._v(" "), (_vm.$slots['body-bottom']) ? _c('div', [_vm._t("body-bottom")], 2) : _vm._e()], 2)]), _vm._v(" "), (_vm.$slots['body-right']) ? _c('div', {
    staticClass: "grid-item-body-right"
  }, [_vm._t("body-right")], 2) : _vm._e()])]), _vm._v(" "), (_vm.$slots['footer']) ? _c('div', {
    staticClass: "grid-item-footer"
  }, [_vm._t("footer")], 2) : _vm._e(), _vm._v(" "), (_vm.isResizable) ? _c('span', {
    ref: "handle",
    class: _vm.resizableHandleClass
  }) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "item",
    staticClass: "vue-grid-layout",
    style: (_vm.mergedStyle)
  }, [(_vm.$slots['grid-header']) ? _c('div', {
    staticClass: "vue-grid-header"
  }, [_vm._t("grid-header")], 2) : _vm._e(), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (_vm.modalConfig.model && _vm.modalConfig.schema) ? _c('modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isModalVisible),
      expression: "isModalVisible"
    }],
    attrs: {
      "is-modal-visible": _vm.isModalVisible,
      "facet-id": _vm.modalConfig.facetId,
      "expanding": _vm.modalConfig.expanding,
      "model": _vm.modalConfig.model,
      "schema": _vm.modalConfig.schema
    },
    on: {
      "close": _vm.closeModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 607:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-container",
    class: {
      'full': _vm.expanding === true
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("\n        Facet Configuration\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.expanding) ? _c('div', [_vm._v("\n        Full Facet Here - " + _vm._s(_vm.expanding) + "\n      ")]) : _c('div', [_c('vue-form-generator', {
    attrs: {
      "schema": _vm.schema,
      "model": _vm.model,
      "options": _vm.formOptions
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "button is-light",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "ban",
      "size": "medium"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("\n              Cancel\n            ")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary config-submit",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "check",
      "size": "med"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("\n              Save\n            ")])])])], 1)])])])
},staticRenderFns: []}

/***/ })

},[205]);


// WEBPACK FOOTER //
// docs/js/grid-dashboard-framework.4c4053ec538f1d124b82.js